export default __webpack_public_path__ + "static/media/distance-literacy.7c9f76e4.png";